<template>
    <div class="">
        <el-button size="small" type="primary" @click="openDrawer" icon="el-icon-upload" plain>上传文件</el-button>
        <el-drawer title="上传文件" :visible.sync="drawer" size="550px" :append-to-body="true" :destroy-on-close="true"
            :before-close="handleClose">
            <div style="width: 100%;padding: 20px;height: 100%;display: flex;flex-direction: column;">
                <div style="flex: 1;">
                    <el-upload class="upload-demo" drag multiple action="#" :before-upload="beforeUpload"
                        :http-request="uploadToQiniu" :on-success="handleSuccess" :on-error="handleError"
                        :on-remove="handleRemove" accept=".jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.pdf">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">
                            只能上传JPG、JPEG、PNG、GIF、XLSX、XLS、DOC、DOCX、PDF文件，且不超过{{ fileSize }}MB
                        </div>
                    </el-upload>
                </div>
                <el-divider></el-divider>
                <div style="display: flex;">
                    <el-button style="flex: 1;" @click="handleClose">取 消</el-button>
                    <el-button type="primary" :disabled="disableds" @click="submitUpload"
                        style="flex: 1;">提交</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { uploadFileManager } from '@/api/FileManager.js'
import { PDFToken } from "@/api/pdfToken.js";
import * as qiniu from "qiniu-js";
export default {
    name: "",
    props: {
        datas: {
            type: Object,
            default: () => { },
        }
    },
    data() {
        return {
            drawer: false,
            // 存储文件上传凭证
            uploadTokens: {},
            // 上传文件列表
            uploadFileList: [],
            disableds: false,
            fileSize: 500,
        }
    },
    methods: {
        async submitUpload() {
            let initParams = {
                path: this.datas.path,
                overwrite: true,
                files: JSON.stringify([...this.uploadFileList]),
            }
            const { data: res } = await uploadFileManager(initParams)
            if (res.Code == 200) {
                this.$message.success('上传成功');
                this.$emit('refresh')
                this.drawer = false;
            }
        },
        //打开上传抽屉
        openDrawer() {
            this.uploadFileList = [];
            this.drawer = true;
        },
        handleClose(done) {
            if (this.uploadFileList.length > 0) {
                this.$confirm('存在上传文件，确认关闭窗口吗？').then(() => {
                    done();
                }).catch(_ => { });
            } else {
                done();
            }
        },

        // 上传前处理，验证文件类型和大小
        beforeUpload(file) {
            const isLt50M = file.size / 1024 / 1024 < this.fileSize;
            if (!isLt50M) {
                this.$message.error(`${file.name} ，传文件大小不能超过 ${this.fileSize}MB!`);
                return false;
            }
            return true;
        },
        // 获取上传token
        async getUploadToken(file) {
            try {
                const suffix = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
                const response = await PDFToken({
                    T_suffix: suffix
                });

                // 检查响应状态，根据http.js中的逻辑，应该检查response.data.Code
                if (response && response.data && (response.data.Code === 200 || response.data.Code === 220)) {
                    // 存储token，使用文件名作为key
                    this.uploadTokens[file.name] = response.data.Data;
                    return response.data.Data;
                } else {
                    const errorMsg = response && response.data && response.data.Msg ? response.data.Msg : '获取上传凭证失败';
                    throw new Error(errorMsg);
                }
            } catch (error) {
                this.$message.error('获取上传凭证失败：' + error.message);
                throw error;
            }
        },

        // 上传到七牛云
        async uploadToQiniu(options) {
            const { file, onSuccess, onError, onProgress } = options;
            this.disableds = true;
            try {
                // 获取上传token
                const token = await this.getUploadToken(file);

                // 生成唯一的文件名
                const timestamp = new Date().getTime();
                const suffix = file.name.substring(file.name.lastIndexOf('.'));
                const key = `file/${timestamp}${suffix}`;

                // 七牛云上传配置 - 根据项目实际情况调整
                const config = {
                    useCdnDomain: true, // 表示是否使用cdn加速域名
                    region: qiniu.region.z2, // 华南区域 - 根据错误提示设置为z2，对应up-z2.qiniup.com
                    chunkSize: 1024, // 4MB分片大小
                    forceDirect: false // 断点续传方式
                };


                const putExtra = {
                    fname: file.name, //文件原始文件名
                    params: {},
                    // mimeType: [] || {} // 自动检测MIME类型
                };

                // 执行上传
                const observable = qiniu.upload(file, key, token, putExtra, config);

                observable.subscribe({
                    next: (res) => {
                        // 上传进度
                        onProgress({ percent: res.total.percent });
                    },
                    error: (err) => {
                        onError(err);
                        this.$message.error('上传失败：' + err.message);
                    },
                    complete: (res) => {
                        // 上传成功
                        onSuccess(res);
                        // 上传成功后，将文件信息添加到列表
                        this.uploadFileList.push({
                            name: file.name,
                            url: res.key, // 假设返回的url是完整的url
                            size: file.size,
                        });
                    }
                });
            } catch (error) {
                onError(error);
            }
        },

        // 上传成功处理
        handleSuccess(response, file, fileList) {
            const uploadingFiles = fileList.filter(f => f.status === 'uploading').length;
            if (uploadingFiles > 0) {
                this.disableds = true;
            } else {
                this.disableds = false;
            }
        },

        // 上传失败处理
        handleError(error, file, fileList) {
            // 可以在这里处理上传失败后的逻辑
            console.error('上传失败', error);
        },
        //删除附件
        handleRemove(file) {
            console.log('删除文件1', file.uid);
            let arr = [...this.uploadFileList]
            const newList = arr.filter(item => item.name !== file.name);
            console.log('删除文件2', newList);
            this.uploadFileList = newList;
        },
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-upload {
    display: block !important;
}

::v-deep .el-upload-dragger {
    width: 100% !important;
}

::v-deep .el-upload-list {
    margin-top: 30px;
}
</style>